/* eslint-disable max-len */
import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { AssetParams } from '../types/asset-selector';
import { AssetSelectorDates } from '../types/asset-selector';
import { ETFParams } from '../types/etf';

export const assetMaster =
  (config: ApiConfig) =>
  (data: { params: AssetParams; limit: number; offset: number; dates?: AssetSelectorDates }): Promise<any> => {
    return fetchWrapper(
      `${config.userapiendpoint}fin-api/asset_master/search/?fmt=object&limit=${data.limit}&offset=${data.offset}`,
      {
        method: 'POST',
        body: JSON.stringify({
          ...data.params,
          start_date: data.dates?.start,
          end_date: data.dates?.end,
        }),
      },
      config
    );
  };

export const searchEtf =
  (config: ApiConfig) =>
  (data: { params: ETFParams; limit: number; offset: number }): Promise<any> => {
    return fetchWrapper(
      `${config.userapiendpoint}fin-api/asset_master/search_etf/?fmt=object&limit=${data.limit}&offset=${data.offset}`,
      {
        method: 'POST',
        body: JSON.stringify(data.params),
      },
      config
    );
  };

export const getEtfFilters = (config: ApiConfig) => (): Promise<any> => {
  return fetchWrapper(
    `${config.userapiendpoint}fin-api/asset_master/etf_filters/?fmt=object`,
    {
      method: 'POST',
      body: JSON.stringify({
        filter_names: ['etf_codes_tree'],
      }),
    },
    config
  );
};

export const getEtfGeoExposure = (config: ApiConfig) => (): Promise<any> => {
  return fetchWrapper(
    `${config.userapiendpoint}fin-api/asset_master/etf_geo_exposure/?fmt=object`,
    {
      method: 'POST',
    },
    config
  );
};

export const getRbics = (config: ApiConfig) => (): Promise<any> => {
  return fetchWrapper(
    `${config.userapiendpoint}fin-api/rbics/?fmt=object`,
    {
      method: 'GET',
    },
    config
  );
};

export const getExchanges =
  (config: ApiConfig) =>
  ({
    quotation_countries,
  }: {
    quotation_countries: string[];
  }): Promise<{
    data: {
      exchange_code: string;
      exchange_description: string;
      quotation_country: string;
      exchange_market_type: string; // e.g., 'UNLISTED'
      iso_mic: string | null;
      iso_mic_level: string | null;
      num_assets: number;
    }[];
  }> => {
    return fetchWrapper(
      `${config.userapiendpoint}fin-api/exchange_code/search/?fmt=object`,
      {
        method: 'POST',
        body: JSON.stringify({ quotation_countries }),
      },
      config
    );
  };
